import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestMatchingFormFeedback from './TestMatchingFormFeedback'
import TestMatchingFormFonts from './TestMatchingFormFont'
import TestMatchingFormStyle from './TestMatchingFormStyle'
import type { TestMatchingFormBrandType, TestMatchingBrandForms } from './testMatchingTypes'

const FORM_MAP: TestMatchingBrandForms = {
  [BrandFormEnum.STYLE]: TestMatchingFormStyle,
  [BrandFormEnum.FEEDBACK]: TestMatchingFormFeedback,
  ...TestMatchingFormFonts,
}

const TestMatchingFormBrand: TestMatchingFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestMatchingFormBrand) as typeof TestMatchingFormBrand
